module.exports = __webpack_public_path__ + "img/horseracing.a74fb381.svg";